const googleStreamId = 'GTM-NDV4DQSS'

export const appendGoogleTagScript = (gtmAuth, gtmPreview) => {
  if (!gtmAuth || !gtmPreview) {
    console.warn('Could not find GTM configuration in the FNC manifest. Skipping GTM')
    return
  }
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
  const scriptElement = document.createElement('script')
  scriptElement.async = true
  scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${googleStreamId}&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`
  document.head.appendChild(scriptElement)
}

export const appendGoogleIframe = (gtmAuth, gtmPreview) => {
  if (!gtmAuth || !gtmPreview) {
    console.warn('Could not find GTM configuration in the FNC manifest. Skipping GTM')
    return
  }
  const gtagNosScript = document.createElement('noscript')
  const gtIframe = document.createElement('iframe')
  gtIframe.setAttribute(
    'src',
    `https://www.googletagmanager.com/gtm.js?id=${googleStreamId}&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`
  )
  gtIframe.setAttribute('width', 0)
  gtIframe.setAttribute('height', 0)
  gtIframe.setAttribute('style', 'display:none;visibility:hidden')
  gtagNosScript.appendChild(gtIframe)
  document.head.appendChild(gtagNosScript)
}
